import type { JobHistoryItem } from './JobHistoryItem';

export class JobHistoryVisibility {
    static getNextItem(historyItems: JobHistoryItem[], index: number): JobHistoryItem | null {
        return index < historyItems.length ? historyItems[index + 1] : null;
    }

    static getPreviousItem(historyItems: JobHistoryItem[], index: number): JobHistoryItem | null {
        return index > 0 ? historyItems[index - 1] : null;
    }

    static setVisibilities(historyItems: JobHistoryItem[]): JobHistoryItem[] {
        for (let ii = 0; ii < historyItems.length; ii++) {
            let item = historyItems[ii];
            let processStatusId = item.getNewProcessStatusId(false);
            if (
                ((item.getData().event_type === 'data_change' &&
                    item.isProcessIncreasing() !== null &&
                    (item.getNewVehicleId(false) !== null ||
                        (processStatusId !== null && processStatusId >= 0))) ||
                    item.getData().event_type === 'confirm' ||
                    item.getData().event_type === 'reject' ||
                    item.getData().event_type === 'create') &&
                Object.keys(item.getData().diff_data).length > 0
            ) {
                item.setVisible(true);
            }

            // don't show data_change if next item is suggest
            let nextItem = this.getNextItem(historyItems, ii);
            if (nextItem !== null) {
                if (
                    item.getData().event_type === 'data_change' &&
                    nextItem?.getData().event_type === 'suggest'
                ) {
                    item.setVisible(false);
                }
            }

            // show suggest if previous item is data_change
            let previousItem = this.getPreviousItem(historyItems, ii);
            if (previousItem !== null) {
                if (
                    previousItem?.getData().event_type === 'data_change' &&
                    item.getData().event_type === 'suggest'
                ) {
                    item.setVisible(true);
                }
            }
        }
        for (let ii = 0; ii < historyItems.length; ii++) {
            let item = historyItems[ii];
            let nextItem = ii < historyItems.length ? historyItems[ii + 1] : null;
            if (
                item.isVisible() &&
                nextItem !== null &&
                nextItem?.isVisible() &&
                item.getData().event_type === 'data_change' &&
                ['confirm', 'reject', 'suggest'].includes(nextItem?.getData().event_type)
            ) {
                item.setVisible(false); // hide data_change if next item is confirm or reject and is visible
            }
        }
        return historyItems;
    }
}
